module.exports = __webpack_public_path__ + "img/feature_buy_th.91ea88db.png";